import { render, staticRenderFns } from "./biBar.vue?vue&type=template&id=3ae64bc4&"
import script from "./biBar.vue?vue&type=script&lang=js&"
export * from "./biBar.vue?vue&type=script&lang=js&"
import style0 from "./biBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports